import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {Tools} from "linkurious-shared";

@Component({
  selector: 'pagination',
  template: `<ul class="pagination" *ngIf="!isBoolean" [class.none]="!numElements || numElements <= limit">
  <li [class.hidden]="!hasPrevious" class="previous">
      <icon class="active"
            name="angle_left"
            [stroke]="16"
            size="6"
            (click)="changePage('previous')"></icon>
  </li>
  <li>
    <span class="active">{{ currentPage }}</span>
  </li>
  <li>
    <span>of</span>
  </li>
  <li>
    <span>{{ numPages() }}</span>
  </li>
  <li [class.hidden]="!hasNext" class="next">
    <icon class="active"
          name="angle_right"
          [stroke]="16"
          size="6"
          (click)="changePage('next')"></icon>
  </li>
</ul>
<ul class="pagination--wl" *ngIf="isBoolean">
  <li [class.disabled]="!hasPrevious" class="previous">
    <a (click)="changePage('previous')">
      <icon name="angle_left"
            [stroke]="16"
            size="6"></icon>
      Prev
    </a>
  </li>
  <li [class.disabled]="!hasNext" class="next">
    <a (click)="changePage('next')">
      Next
      <icon name="angle_right"
            [stroke]="16"
            size="6"></icon>
    </a>
  </li>
</ul>
`,
  styles: [`.pagination{padding:0;margin:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.pagination li{display:inline;position:relative;text-align:center;opacity:1;transition:opacity 350ms ease}.pagination li.hidden{opacity:0;transition:opacity 350ms ease}.pagination li.previous{margin-right:30px;cursor:pointer}.pagination li.previous icon{position:absolute;left:0;top:30%}.pagination li.next{margin-left:30px;cursor:pointer}.pagination li.next icon{position:absolute;right:0;top:30%}.pagination span{color:#878787;text-decoration:none;border-radius:5px}.pagination span.active{color:#363636}.pagination--wl{width:100px;padding:0;margin:0;display:flex;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;list-style:none}.pagination--wl li{position:relative;flex:0 0 50px;cursor:pointer}.pagination--wl li.previous{padding-left:15px}.pagination--wl li.previous icon{position:absolute;left:0;top:35%}.pagination--wl li.next{text-align:right;padding-right:15px}.pagination--wl li.next icon{position:absolute;right:0;top:35%}`]
})
export class PaginationComponent implements OnChanges  {

  @Input('numElements') numElements: number | boolean;
  @Input('limit') limit: number;
  @Input('next') next: boolean;
  @Input('page') page: number = 1;
  @Output('pageChange') pageChange: EventEmitter<number> = new EventEmitter<number>();

  public isBoolean: boolean;
  public pages: Array<any>;
  public hasPrevious: boolean = false;
  public hasNext: boolean = false;
  private _currentPage: number;

  constructor() {}

  ngOnChanges() {
    this.currentPage = this.page;
    if(typeof this.numElements === 'boolean') {
      this.isBoolean = true;
      this.hasNext = this.numElements
    } else if ( Tools.isDefined(this.numElements) ) {
      this.pages = Array(this.numPages()).fill(0).map((x, i) => i);
      if (this.pages.length <= 1) {
        this.pages = [];
        this.hasPrevious = false;
        this.hasNext = false;
      } else {
        this.hasNext = true;
      }
    }
    if(this.currentPage > 1) {
      this.hasPrevious = true;
    }
  }

  set currentPage(page: number) {
    this._currentPage = page;
  }

  get currentPage() {
    return this._currentPage;
  }

  public numPages(): number {
    if(typeof this.numElements === 'boolean') {
      return 0;
    }
    return Math.ceil(this.numElements / this.limit );
  }

  public changePage (page: number | string) {
    if (page === 'previous') {
      if (this.currentPage !== 1) {
        this.currentPage = this.currentPage - 1;
      }
    } else if (page === 'next') {
      if (this.currentPage !== this.numPages()) {
        this.currentPage = this.currentPage + 1;
      }
    } else {
      this.currentPage = +this.currentPage;
    }
    this.hasPrevious = this.currentPage !== 1;
    this.hasNext = (typeof this.numElements === 'boolean')
      ? this.numElements
      : this.currentPage !== this.numPages();
    this.pageChange.emit(this.currentPage);
  }
}
